export default [
    '/home',
    '/directory/companies',
    '/directory/individuals',
    '/directory/clients',
    '/directory/prospects',
    '/directory/suppliers',
    '/thirds/client/',
    '/directory/contacts',
    '/peoples/',
    '/opportunities',
    '/prospection/opportunities',
    '/sales/estimate',
    '/?_f=estimateOverview&id=',
    '/sales/invoice',
    '/?_f=invoiceOverview&id=',
    '/sales/creditnote',
    '/?_f=creditnoteOverview&id=',
    '/sales/order',
    '/?_f=orderOverview&id=',
    '/sales/delivery',
    '/?_f=deliveryOverview&id=',
    '/sales/proforma',
    '/?_f=proformaOverview&id=',
    '/purchase/purInvoice',
    '/?_f=purchases_purInvoiceOverview&id=',
    '/purchase/purCreditNote',
    '/?_f=purchases_purCreditNoteOverview&id=',
    '/purchase/purOrder',
    '/?_f=purchases_purOrderOverview&id=',
    '/purchase/purDelivery',
    '/?_f=purchases_purDeliveryOverview&id=',
    '/?_f=proposal_documents',
    '/?_f=proposal_proposal&type=propdocument&id=',
    '/thirds/supplier',
    '/thirds/prospect',
    '/?_f=emailPreferences&action=emailsCustom',
    '/emails/templates',
];
